var Project = function(opts){
	var self = this;
	self.id = ko.observable(opts.id || 0);
	self.title = ko.observable(opts.title || '');
	self.groupsSelected = ko.observableArray(opts.groupsSelected || []);
	self.selected = ko.observable(opts.groupsSelected.length > 0);
	self.groups = ko.observableArray(opts.groups || []);
	self.group = ko.observable();

	self.getGroups = function(){
		return self.groups().filter(function(i) { return self.groupsSelected.indexOf(i) === -1 });
	};

	self.addGroup = function(){
		if(!self.group())
			return;
		self.groupsSelected.push(self.group());
	};

	self.removeGroup = function(group){
		self.groupsSelected.remove(group);
	};
};